module.exports = __webpack_public_path__ + "img/ata-messi.7af08840.png";